import { HiOutlineMenu } from "react-icons/hi";
import { useWindowWidth } from "ui/utils/hooks";
import { INSearchField } from "ui/pages/app/components/inputs/INSearchField";
import { translate } from "ui/i18n";
import { useContext } from "react";
import { SidebarContext } from "ui/pages/layouts/components/SidebarContext";
import { AISearchTooltip } from "ui/pages/app/components/activities/AI/AISearchTooltip";
import { useDisclosure } from "@chakra-ui/hooks";
import { ModalAISearch } from "ui/pages/app/components/activities/AI/ModalAISearch";
import { AISearchButton } from "ui/pages/app/components/activities/AI/AISearchButton";

interface IProps {
  search?: string;
  setSearch?: (value: string) => void;
  title: string;
  placeholder?: "TechniqueName" | "TutorialName" | "VisualSupportName";
  subTitle?: string;
  AdditionalButton?: () => JSX.Element;
  activityCount?: number;
  aiSearch?: boolean;
  resetAISearchFilters?: () => void;
  className?: string;
}

export function PageHeader({
  search,
  setSearch,
  title,
  placeholder,
  subTitle,
  AdditionalButton,
  activityCount,
  aiSearch,
  resetAISearchFilters,
  className,
}: IProps) {
  const isDesktop = useWindowWidth();
  const { setIsSidebarOpen } = useContext(SidebarContext);
  const modalAISearch = useDisclosure();

  return (
    <>
      <div
        className={`md:items-top flex items-center justify-between ${
          className || ""
        }`}
      >
        {!isDesktop && (
          <button onClick={() => setIsSidebarOpen(true)}>
            <HiOutlineMenu size={34} />
          </button>
        )}
        <div>
          <h1 className="text-base text-secondaryGrey-900 md:text-3xl">
            {title}
          </h1>
          {subTitle && isDesktop && (
            <h4 className="mtext-lg mt-2 text-secondaryGrey-900">
              {activityCount !== undefined && (
                <span className="me-1 font-bold">{activityCount}</span>
              )}
              {subTitle}
            </h4>
          )}
        </div>
        {!AdditionalButton && (
          <div
            style={{ opacity: typeof search === "string" && setSearch ? 1 : 0 }}
            className="flex items-center space-x-3"
          >
            {isDesktop ? (
              <INSearchField
                placeholder={translate(
                  `ns1:Input.Placeholders.${placeholder || "Keywords"}`
                )}
                value={search}
                setValue={setSearch}
                width={aiSearch ? "350px" : "450px"}
              />
            ) : (
              <div className="w-[34px]" />
            )}
            {isDesktop && aiSearch && (
              <AISearchTooltip requestFeedback>
                <AISearchButton onClick={modalAISearch.onOpen} />
              </AISearchTooltip>
            )}
          </div>
        )}
        {!isDesktop && AdditionalButton && <AdditionalButton />}
      </div>
      {subTitle && !isDesktop && (
        <h4 className="mt-4 px-4 text-center text-sm text-secondaryGrey-900">
          {activityCount !== undefined && (
            <span className="me-1 font-bold">{activityCount}</span>
          )}
          {subTitle}
        </h4>
      )}

      {aiSearch && resetAISearchFilters && (
        <ModalAISearch
          isOpen={modalAISearch.isOpen}
          onClose={modalAISearch.onClose}
          requestFeedback
          resetFilters={resetAISearchFilters}
        />
      )}
    </>
  );
}
